import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from 'app/api-service/api.service';
import { BackupSubscription, LockState } from '@sk-models';

@Component({
  selector: 'sk-lock-subscription-modal',
  templateUrl: './lock-subscription-modal.component.html',
  styleUrls: ['./lock-subscription-modal.component.scss']
})
export class LockSubscriptionModalComponent {
  subscription: BackupSubscription;
  lockStates = LockState;
  error: string;

  constructor(
      @Inject(MAT_DIALOG_DATA) data: { subscription: BackupSubscription },
      private apiService: ApiService,
      public dialogRef: MatDialogRef<LockSubscriptionModalComponent>) {
    if(data){
      this.subscription = data?.subscription;
    }
  }

  lockResource(lockState: LockState) {
    this.apiService.lockResource(
      this.subscription.backupServiceId,
      this.subscription.id,
      lockState === LockState.Locked,
      this.subscription.resourceKey.resourceType)
      .subscribe({
        complete: () => {
          this.subscription.lockState = lockState;
          this.dialogRef.close()
        },
        error: (e) => this.error = `Request failed! Details: ${JSON.stringify(e)}`
      })
  }
}
